import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { useMemo } from 'react';
import { createContext } from 'use-context-selector';

import { withErrorHandler } from 'watchtower-ui/components/common/ErrorBoundary/ErrorBoundary';
import useQueryParamState from 'watchtower-ui/customHooks/useQueryParamState';
import type { TCurrency } from 'watchtower-ui/types/currency';
import { DEFAULT_CURRENCY } from 'watchtower-ui/types/currency';

type CurrencyContext = {
  selectedCurrency: TCurrency;
  setSelectedCurrency: Dispatch<SetStateAction<TCurrency>>;
};

const Context = createContext<CurrencyContext>({
  selectedCurrency: DEFAULT_CURRENCY,
  setSelectedCurrency: () => {},
});

const ContextManager = withErrorHandler(({ children }: PropsWithChildren) => {
  const [, selectedCurrency, setSelectedCurrency] = useQueryParamState<TCurrency>('currencyUnit', DEFAULT_CURRENCY);

  const value = useMemo(
    (): CurrencyContext => ({
      selectedCurrency,
      setSelectedCurrency,
    }),
    [selectedCurrency, setSelectedCurrency],
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
}, true);

export default {
  Context,
  ContextManager,
};
